import React, { useState } from 'react';
import { AuthPermissions } from 'skipify-types';

import DetailModal from '../MITDetails/modal';
import { MIT } from '../../../../store/modules/mit/types';
import { MITActions, getAllowedMITActions } from '../../constants';
import { useMerchant } from '../../../../contexts/MerchantContext';
import { ActionsPopover } from '../../../../common/ActionsPopover';

interface Props {
  mit: MIT;
}

export type MITDetailsPage = 'details' | 'refund';

export const MITActionsPopover = ({ mit }: Props) => {
  const { status } = mit;
  const { merchantId, canAccess } = useMerchant();
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [detailsOpenPage, setDetailsOpenPage] = useState<MITDetailsPage>('details');

  const allowedActions = getAllowedMITActions(status);

  return (
    <>
      <ActionsPopover
        ariaLabel="MIT Actions"
        actions={[
          {
            label: 'Details',
            onClick: () => {
              setDetailsOpenPage('details');
              setIsDetailModalOpen(true);
            },
            disabled:
              !canAccess(AuthPermissions.READ_MIT) && !canAccess(AuthPermissions.READ_OWN_MIT),
            shouldRender: allowedActions.includes(MITActions.DETAILS),
          },
          {
            label: 'Refund',
            onClick: () => {
              setDetailsOpenPage('refund');
              setIsDetailModalOpen(true);
            },
            disabled:
              !canAccess(AuthPermissions.REFUND_MIT) && !canAccess(AuthPermissions.REFUND_OWN_MIT),
            shouldRender: allowedActions.includes(MITActions.REFUND),
          },
        ]}
      />
      <DetailModal
        merchantId={merchantId}
        isOpen={isDetailModalOpen}
        onClose={() => {
          setIsDetailModalOpen(false);
          setDetailsOpenPage('details');
        }}
        mit={mit}
        defaultOpenPage={detailsOpenPage}
      />
    </>
  );
};
